import React, { Fragment } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import {
  Field,
  Label,
  LabelText,
  LabelIcon,
  Option,
  Required,
  Input,
  Salary,
  SalaryElement,
  Select,
  Error,
} from "../styles/edit-form-styles";
import tooltips from "./tooltips";

library.add(faInfoCircle);

const PermanentActiveContent = (props) => {
  const {
    activeRadioButtonID,
    salaryMin,
    salaryMax,
    inputOnChange,
    recruiterFeePercentage,
    errors,
    currencySymbol,
    currencyId,
    currencyOptions,
  } = props;
  let activeContent;

  switch (activeRadioButtonID) {
    case "range":
      activeContent = (
        <Fragment>
          <Salary>
            <SalaryElement>
              <Label htmlFor="salary-min">
                <LabelText>
                  Salary in {currencySymbol} from
                  <Required>*</Required>
                </LabelText>
                <LabelIcon />
              </Label>
              <Input
                error={!!errors.salary_min}
                type="text"
                name="salaryMin"
                id="salary-min"
                value={salaryMin}
                onChange={inputOnChange}
              />
            </SalaryElement>
            <SalaryElement>to</SalaryElement>
            <SalaryElement>
              <Label htmlFor="salary-max" />
              <Input
                type="text"
                name="salaryMax"
                id="salary-max"
                value={salaryMax}
                onChange={inputOnChange}
              />
            </SalaryElement>
            {errors.salary_min && (
              <Error>{`For salary ${errors.salary_min}.`}</Error>
            )}
          </Salary>
          <Salary>
            <SalaryElement>
              <Label htmlFor="currency">
                <LabelText>
                  Currency <Required>*</Required>
                </LabelText>
              </Label>
              <Select
                error={!!errors.currency_id}
                onChange={inputOnChange}
                name="currencyId"
                id="currency"
                value={currencyId}
                title="Please select a currency..."
              >
                <Option value="">Please select a currency...</Option>
                {currencyOptions.map((currencyOption) => (
                  <Option key={currencyOption.id} value={currencyOption.id}>
                    {currencyOption.name}
                  </Option>
                ))}
              </Select>
            </SalaryElement>
            <SalaryElement />
            <SalaryElement>
              <Label htmlFor="agency-fee-pounds">
                <LabelText>
                  Agency Fee in % <Required>*</Required>
                </LabelText>
                <LabelIcon>
                  <FontAwesomeIcon
                    data-tip={tooltips.agencyFee}
                    data-for="agency-fee-tooltip"
                    icon="info-circle"
                  />
                  <ReactTooltip
                    place="left"
                    type="dark"
                    effect="solid"
                    aria-haspopup="true"
                    id="agency-fee-tooltip"
                  />
                </LabelIcon>
              </Label>
              <Input
                error={!!errors.placement_fee_percent}
                type="text"
                name="recruiterFeePercentage"
                id="agency-fee"
                value={recruiterFeePercentage}
                onChange={inputOnChange}
              />
              {errors.currency_id && <Error>Please select a currency.</Error>}
              {errors.placement_fee && (
                <Error>{`Fee ${errors.placement_fee}.`}</Error>
              )}
              {errors.placement_fee_percent && (
                <Error>{`${errors.placement_fee_percent}.`}</Error>
              )}
            </SalaryElement>
          </Salary>
        </Fragment>
      );
      break;
    default:
      activeContent = (
        <Fragment>
          <Salary>
            <SalaryElement>
              <Label htmlFor="salary-min">
                <LabelText>
                  Salary<Required>*</Required>
                </LabelText>
              </Label>
              <Input
                error={errors.salary_min}
                type="text"
                name="salaryMin"
                id="salary-min"
                value={salaryMin}
                onChange={inputOnChange}
              />
            </SalaryElement>
            <SalaryElement />
            <SalaryElement>
              <Label htmlFor="currency">
                <LabelText>
                  Currency <Required>*</Required>
                </LabelText>
              </Label>
              <Select
                error={!!errors.currency_id}
                onChange={inputOnChange}
                name="currencyId"
                id="currency"
                value={currencyId}
                title="Please select a currency..."
              >
                <Option value="">Please select a currency...</Option>
                {currencyOptions.map((currencyOption) => (
                  <Option key={currencyOption.id} value={currencyOption.id}>
                    {currencyOption.name}
                  </Option>
                ))}
              </Select>
            </SalaryElement>
            {errors.currency_id && <Error>Please select a currency.</Error>}
            {errors.salary_min && <Error>{`${errors.salary_min}.`}</Error>}
          </Salary>
          <Field>
            <Label htmlFor="agency-fee-pounds">
              <LabelText>
                Agency Fee in % <Required>*</Required>
              </LabelText>
              <LabelIcon>
                <FontAwesomeIcon
                  data-tip={tooltips.agencyFee}
                  data-for="agency-fee-tooltip"
                  icon="info-circle"
                />
                <ReactTooltip
                  place="left"
                  type="dark"
                  effect="solid"
                  aria-haspopup="true"
                  id="agency-fee-tooltip"
                />
              </LabelIcon>
            </Label>
            <Input
              error={!!errors.placement_fee_percent}
              type="text"
              name="recruiterFeePercentage"
              id="agency-fee"
              value={recruiterFeePercentage}
              onChange={inputOnChange}
            />
            {errors.placement_fee && (
              <Error>{`Fee ${errors.placement_fee}.`}</Error>
            )}
            {errors.placement_fee_percent && (
              <Error>{`${errors.placement_fee_percent}`}</Error>
            )}
          </Field>
        </Fragment>
      );
  }
  return activeContent;
};

export default PermanentActiveContent;
